// extracted by mini-css-extract-plugin
export default {"title":"title___JM6_x"};